export function buildMonthGrid(year, monthZeroIndexed) {
  const firstOfMonth = new Date(year, monthZeroIndexed, 1);
  const startIndex = (firstOfMonth.getDay() + 6) % 7;
  const firstVisible = new Date(firstOfMonth);
  firstVisible.setDate(1 - startIndex);

  const weeks = [];
  const cursor = new Date(firstVisible);
  for (let w = 0; w < 6; w++) {
    const week = [];
    for (let d = 0; d < 7; d++) {
      week.push(new Date(cursor));
      cursor.setDate(cursor.getDate() + 1);
    }
    weeks.push(week);
  }
  return weeks;
}

export function pad(n) {
  return String(n).padStart(2, "0");
}

export function formatDateKey(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function parseListingDateToken(token) {
  if (!token) return null;
  const s = String(token).trim();
  const iso = s.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
  if (iso) {
    const [, y, m, d] = iso;
    return `${y}-${pad(m)}-${pad(d)}`;
  }
  const mdy = s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (mdy) {
    const [, mm, dd, yyyy] = mdy;
    return `${yyyy}-${pad(mm)}-${pad(dd)}`;
  }
  const parsed = new Date(s);
  if (!isNaN(parsed.getTime())) {
    return formatDateKey(parsed);
  }
  return null;
}

export function formatYearMonth(year, monthZeroIndexed) {
  return `${year}-${String(monthZeroIndexed + 1).padStart(2, "0")}`;
}

export function parseYearMonthToken(token) {
  if (!token) return null;
  const m = String(token).trim().match(/^(\d{4})-(\d{1,2})$/);
  if (!m) return null;
  const year = parseInt(m[1], 10);
  const month = parseInt(m[2], 10);
  if (month < 1 || month > 12) return null;
  return { year, monthIndex: month - 1 };
}
